module.exports = __webpack_public_path__ + "static/media/37.1e12dd3f.jpg";